module.exports = __webpack_public_path__ + "static/media/filter-tree.4a365bc6.png";